import * as React from "react";
import { useBrand } from "@/hooks/useBrand";

/** Marca em texto: "Empresarial" + "Prime" (rosa) */
export default function BrandText({ className = "" }: { className?: string }) {
  const { isConecta } = useBrand();
  return (
    <a 
      href="/" 
      className={`inline-flex select-none font-semibold tracking-tight ${className}`} 
      aria-label={isConecta ? "Prime Conecta" : "Empresarial Prime"}
    >
      <span>{isConecta ? "Prime" : "Empresarial"}</span>
      <span className="text-primary ml-1">{isConecta ? "Conecta" : "Prime"}</span>
    </a>
  );
}
